import React from 'react';
import LegalPage from './LegalPage';
import privacyText from './privacyText';

export default function PrivacyPage() { return <LegalPage markdown={privacyText} />; }
